import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReturnsinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M59 17L47 6H17L5 17v40h54zM5 18h54"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M46 26v9h-8M17 49v-9h8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 34c1.375-4.592 4.648-7.708 9-9 3.69-.657 7.896.646 11 4l6 6M17 40l6 6c3.104 3.354 7.31 4.657 11 4 4.352-1.292 7.625-4.408 9-9",
				strokeLinecap: "round"
			})
		]
	})
});
export default SvgReturnsinline;
